import React from "react";
import type { FormSubmissionDetailDto, FormSubmissionDto } from "src/http";

type FormSubmissionDetailUpdate = (formSubmissionGuid: string, updates: Partial<FormSubmissionDetailDto>) => void;
type FormSubmissionsUpdate = (formSubmissionGuid: string, updates: Partial<FormSubmissionDto>) => void;

interface ISignalRFormSubmissionsContext {
  sendUpdateFormSubmissions: FormSubmissionsUpdate;
  sendUpdateFormSubmissionDetail: FormSubmissionDetailUpdate;
  onShouldUpdateFormSubmissions: (handler: FormSubmissionsUpdate) => void;
  onShouldUpdateFormSubmissionDetail: (handler: FormSubmissionDetailUpdate) => void;
  offShouldUpdateFormSubmissions: (handler: FormSubmissionsUpdate) => void;
  offShouldUpdateFormSubmissionDetail: (handler: FormSubmissionDetailUpdate) => void;
}

const SignalRFormSubmissionsContext = React.createContext<ISignalRFormSubmissionsContext>({
  sendUpdateFormSubmissions: () => null,
  sendUpdateFormSubmissionDetail: () => null,
  onShouldUpdateFormSubmissions: () => null,
  onShouldUpdateFormSubmissionDetail: () => null,
  offShouldUpdateFormSubmissions: () => null,
  offShouldUpdateFormSubmissionDetail: () => null,
});

export { SignalRFormSubmissionsContext };
export type { FormSubmissionDetailUpdate, FormSubmissionsUpdate };
